import React, { useState } from 'react';
import OtpInput from 'react-otp-input';
import { useDispatch, useSelector } from 'react-redux';
import { sendOtp, verifyOtp } from '../store/authSlice';

const Login = () => {
  const [mobile, setMobile] = useState('');
  const [otp, setOtp] = useState('');

  const dispatch = useDispatch();
  const { otpSent, isLoading, error } = useSelector((state) => state.auth);

  const handleSendOtp = (e) => {
    e.preventDefault();
    dispatch(sendOtp(mobile));
  };

  const handleVerifyOtp = (e) => {
    e.preventDefault();
    dispatch(verifyOtp({ mobile, otp }));
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 to-blue-100 px-4">
      <div className="bg-white shadow-lg rounded-xl w-full max-w-md p-8 space-y-6">
        <div className="flex justify-center">
          <img src="/logo.png" alt="Logo" className="h-16 w-auto" />
        </div>

        <h2 className="text-2xl font-bold text-center text-gray-700">
          {otpSent ? 'Enter OTP' : 'Login with Mobile'}
        </h2>

        {error && <p className="text-sm text-red-500 text-center">{error}</p>}

        <form onSubmit={otpSent ? handleVerifyOtp : handleSendOtp} className="space-y-4">
          {!otpSent ? (
            <input
              type="tel"
              maxLength={12}
              value={mobile}
              onChange={(e) => setMobile(e.target.value)}
              placeholder="Enter mobile number"
              required
              className="w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-2 focus:ring-blue-500"
            />
          ) : (
            <OtpInput
  value={otp}
  onChange={setOtp}
  numInputs={6}
  renderInput={(props) => <input {...props} />}
  isInputNum
  inputStyle="w-10 h-12 mx-1 text-center border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
  containerStyle="flex justify-center"
/>
          )}

          <button
            type="submit"
            disabled={isLoading}
            className="w-full bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2 rounded-md transition duration-200"
          >
            {isLoading ? 'Please wait...' : otpSent ? 'Verify OTP' : 'Send OTP'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;
